module.exports = __webpack_public_path__ + "assets/print-white.bf09b4b1b23deb4aca069de73f79d6cc.svg";